//lte bands source: https://github.com/qvil/lte-earfcn-calculator/blob/master/lteBandTable.json
//calculator source: https://github.com/qvil/lte-earfcn-calculator/blob/master/src/index.js
import table from './lteBandTable.json';

export type TFrequencyConverterResult = {
	frequency: number;
	bandType: string;
	band?: number | null;
};

export const FREQUENCY_DECIMALS = 3;

export class ConverterLTE {
	static readonly MAX_AVAILABLE_EARFCN = 60_139;

	private static readonly EARFCN_UPLINK_LOWER_BOUND = 18_000;
	private static readonly EARFCN_UPLINK_UPPER_BOUND = 36_000;
	private static readonly EARFCN_TDD_LOWER_BOUND = 36_000;
	private static readonly EARFCN_TDD_UPPER_BOUND = 65_535;
	private static readonly EARFCN_SPECIAL_UPPER_BOUND = 98_303;

	private static readonly FREQ_STEP_MHZ_PER_EARFCN = 0.1;
	private static readonly FREQ_STEP_EARFCN = 10;
	private static readonly EARFCN_ADJUSTMENT = 1;

	static earfcnToFreq(earfcn: number): TFrequencyConverterResult {
		const result: TFrequencyConverterResult = { frequency: NaN, bandType: '', band: null };

		for (const element of table) {
			let freq: number | undefined;

			// Check Uplink Earfcn
			if (earfcn >= ConverterLTE.EARFCN_UPLINK_LOWER_BOUND && earfcn < ConverterLTE.EARFCN_UPLINK_UPPER_BOUND) {
				if (earfcn >= element.NUL_Min! && earfcn <= element.NUL_Max!) {
					freq = element.FUL_Low! + ConverterLTE.FREQ_STEP_MHZ_PER_EARFCN * (earfcn - element.NUL_Min!);
					result.bandType = element.bandType;
					result.band = element.band;
				}
			}
			// Check Downlink Earfcn
			else if (
				earfcn < ConverterLTE.EARFCN_UPLINK_UPPER_BOUND ||
				(earfcn > ConverterLTE.EARFCN_TDD_UPPER_BOUND && earfcn <= ConverterLTE.EARFCN_SPECIAL_UPPER_BOUND)
			) {
				if (earfcn >= element.NDL_Min && earfcn <= element.NDL_Max) {
					freq = element.FDL_Low + ConverterLTE.FREQ_STEP_MHZ_PER_EARFCN * (earfcn - element.NDL_Min);
					result.bandType = element.bandType;
					result.band = element.band;
				}
			}
			// Check TDD Uplink Earfcn
			else if (earfcn >= ConverterLTE.EARFCN_TDD_LOWER_BOUND && earfcn <= ConverterLTE.EARFCN_TDD_UPPER_BOUND) {
				if (earfcn >= element.NDL_Min && earfcn <= element.NDL_Max) {
					freq = element.FDL_Low + ConverterLTE.FREQ_STEP_MHZ_PER_EARFCN * (earfcn - element.NDL_Min);
					result.bandType = element.bandType;
					result.band = element.band;
				}
			}

			if (freq !== undefined) {

				result.frequency = +(freq).toFixed(FREQUENCY_DECIMALS);
				return result;
			}
		}

		return result;
	}

	static freqToEarfcnByBand(inputBand: number, freq: number): number {
		for (const element of table) {
			if (inputBand === element.band) {
				if (freq >= element.FDL_Low && freq <= element.FDL_High) {
					const earfcnCalc = (freq - element.FDL_Low) * ConverterLTE.FREQ_STEP_EARFCN + element.NDL_Min;
					const earfcn = earfcnCalc > element.NDL_Max
						? earfcnCalc - ConverterLTE.EARFCN_ADJUSTMENT
						: earfcnCalc;
					return Math.round(earfcn);
				} else if (freq >= element.FUL_Low! && freq <= element.FUL_High!) {
					const earfcnCalc = (freq - element.FUL_Low!) * ConverterLTE.FREQ_STEP_EARFCN + element.NUL_Min!;
					const earfcn = earfcnCalc > element.NUL_Max!
						? earfcnCalc - ConverterLTE.EARFCN_ADJUSTMENT
						: earfcnCalc;
					return Math.round(earfcn);
				}
			}
		}

		return NaN;
	}
}
